import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction } = optionsToDisplay;

  const [listActionLog, setListActionLog] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const location = useLocation();

  const [query, setQuery] = useState({ page: null, order: 'createdAt DESC', keyword: '', limit: 10 });
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllActionLogs();
    }
  }, [query]);

  const findAllActionLogs = () => {
    setLoading(true);
    AxiosInstance.get('/action-log', { params: query })
      .then((response) => {
        setListActionLog(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('action-log.ERROR_GET_ACTION_LOGS'), '', 'error');
        setLoading(false);
      });
  };

  const updateActionLog = (id) => {
    history.push({
      pathname: '/action-log/update',
      params: {
        id: id,
      },
    });
  };

  const attributes = [
    { name: 'action', title: t('table.action'), nestedObject: [], type: 'actionLog', order: true },
    { name: 'user', title: t('table.user'), nestedObject: [], type: 'text', order: true },
    { name: 'message', title: t('table.message'), nestedObject: [], type: 'actionLogMessage', order: true },
    { name: 'createdAt', title: t('table.createdAt'), nestedObject: [], type: 'dateTime', order: true },
  ];

  const actions = { details: null, delete: null, update: null };

  return {
    attributes,
    actions,
    listActionLog,
    findAllActionLogs,
    totalPages,
    query,
    loading,
  };
};

export default useForm;
